import React from 'react';
import Modal from 'jd-library/Modal';
import withPortal from 'jd-library/withPortal';
import styles from './transaction-type.scss';

const ProductChangeModal = props => {
    const { isService } = props;
    return (
        <Modal
                settings={{
                    modalId: 'transactiontype-modal',
                    variant: 'action',
                    class: ''
                }}
                onHidden={props.onHidden}
                backdropStatic={true}
            >
                <Modal.CloseIcon iconClass={'icon-HDRcross'} />
                <Modal.Header>{
                    <div className={styles['header-txt']}>
                        <span>{`Change ${isService?'Service':'Product'} Type to Single ${isService?'Service':'Product'}`}</span>
                    </div>}</Modal.Header>
                <Modal.Body className={styles['body-container']}>
                    <div>
                        {`Changing ${isService ? 'Service' : 'Product'} Type to Single ${isService? 'Service':'Product'} will result in losing Multiple Variant data. Are you sure you want to change ${isService ? 'service': 'product'} type to Single ${isService?'Service':'Product'}?`}
                    </div>
                </Modal.Body>
                <Modal.CenterButton className={styles['change-btn']} clickHandler={props.changeType}>
                    {`Change ${isService?'Service':'Product'} Type`}
                </Modal.CenterButton>
            </Modal>
    )
};

export default withPortal(ProductChangeModal);